import { prefetchPlayResource } from "@/features/play/records";
import { ProductRouteError } from "@/session/product-route-frame";
import { createFileRoute } from "@tanstack/react-router";
import { PlayRequestsPage, PlayPending } from "@/features/play";

export const Route = createFileRoute("/_site/$coworld/$league/play_/requests")({
  loader: ({ context, location }) => {
    prefetchPlayResource({
      client: context.queryClient,
      href: location.href,
      resource: "requests",
    });
  },
  pendingComponent: PlayPending,
  errorComponent: ProductRouteError,
  head: () => ({
    meta: [
      { title: "Experience requests · Softmax" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: PlayRequestsPage,
});
